export default __webpack_public_path__ + "static/media/nftupdated.5bf1afff.png";